import * as React from "react";

export type TitleCardModuleProps = {
  title: string;
  /** Unsplash (or other) hero image — full URL */
  imageUrl?: string;
  /** Solid fallback when `imageUrl` is omitted */
  bgColor?: string;
  textColor?: string;
};

const TitleCardModule: React.FC<TitleCardModuleProps> = ({
  title,
  imageUrl,
  bgColor = "bg-[#092c4c]",
  textColor = "text-white",
}) => {
  if (imageUrl) {
    return (
      <div className="genre-card">
        <img
          src={imageUrl}
          alt=""
          loading="lazy"
          decoding="async"
          className="genre-card-image"
        />
        <div className="genre-card-scrim" aria-hidden />
        <div className="genre-card-body">
          <span className="genre-card-title">{title}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`genre-card genre-card--solid ${bgColor} ${textColor} text-center text-xl font-bold px-6 py-16 min-h-[200px] border-2 border-black/40 flex items-center justify-center`}
    >
      {title}
    </div>
  );
};

export default TitleCardModule;
